import "../../../static/js/loaders/image-slider";

var $slickSlider = $(".slick-slider");
var $slickNav = $(".slider-nav");
var $slider_height;
$slickSlider.on("init", function (event, slick, currentSlide, nextSlide) {
  $slider_height = $(this).height();
});
$slickSlider.on("init reInit afterChange", function (
  event,
  slick,
  currentSlide,
  nextSlide
) {
  var i = (currentSlide ? currentSlide : 0) + 1;
  $(".slide-current").text(i);
  $(".slide-count").text(slick.slideCount);
  $("img", $slickNav).removeClass("active");
  $("img:eq(" + (i - 1) + ")", $slickNav).addClass("active");
  adjustSlider();
  var img_hight = $(".slider-image-container").height();
  $(".slick-arrow").css("top", img_hight / 2);
});

$slickSlider.slick();

// $(".show-more").on("click", function() {
//   $(".image-description").toggleClass("show");
//   $(".slider-nav").toggleClass("show");
//   adjustSlider();
//   if ($(".material-icons", this).text() === "keyboard_arrow_down") {
//     $(".material-icons", this).text("keyboard_arrow_up");
//   } else {
//     $(".material-icons", this).text("keyboard_arrow_down");
//   }
// });

$("div", $slickNav).on("click", function () {
  $slickSlider.slick("slickGoTo", $(this).index());
});

function adjustSlider() {
  var $el = $(".image-description");
  if ($el.hasClass("show")) {
    var sl_height =
      $(".slick-active")
        .find(".image-description")
        .height();
    $slickSlider.height($slider_height + sl_height);
  } else {
    $slickSlider.attr("style", null);
  }
}